import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ProductFeedWithFilter from "./ProductFeedWithFilter";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(2),
    },
  },
}));

const ProductFeedSearch = (props) => {
  const classes = useStyles();
  const { onApplyFilter, searchString } = props;

  return (
    <div className={classes.root}>
      <ProductFeedWithFilter onApplyFilter={onApplyFilter} fixedSearchString={searchString} />
    </div>
  );
};

export default ProductFeedSearch;
